module.exports = __webpack_public_path__ + "4050a4e3efb4d9c15c52f2792e48669a.svg";